import { createSlotRecipeContext, HTMLChakraProps } from '@chakra-ui/react';
import { LatLongInput } from '@components/ui/coordinatesInput/LatLongInput';
import { UnitSelector } from '@components/ui/coordinatesInput/UnitSelector';

import { CoordinatesUnit } from '@/types/commons/commons.types';

import { PositionPicker } from './PositionPicker';

const { withProvider, withContext } = createSlotRecipeContext({ key: 'gpsCoordinates' });

export type GPSCoordinatesRootProps = HTMLChakraProps<'div'>;
export const GPSCoordinatesRoot = withProvider<HTMLDivElement, GPSCoordinatesRootProps>('div', 'root');

export type GPSCoordinatesUnitSelectorProps = HTMLChakraProps<'div'> & {
  unit: CoordinatesUnit | null;
  onUnitChange: (value: CoordinatesUnit | null) => void;
};
export const GPSCoordinatesUnitSelector = withContext<HTMLDivElement, GPSCoordinatesUnitSelectorProps>(
  UnitSelector,
  'unitSelector',
);

export type GPSCoordinatesPositionPickerProps = HTMLChakraProps<'button'>;
export const GPSCoordinatesPositionPicker = withContext<HTMLDivElement, GPSCoordinatesPositionPickerProps>(
  PositionPicker,
  'positionPicker',
);

export type GPSCoordinatesInputProps = {
  type: 'latitude' | 'longitude';
  name: string;
  unit: CoordinatesUnit | null;
  readOnly?: boolean;
} & Omit<HTMLChakraProps<'div'>, 'value' | 'onChange'>;
export const GPSCoordinatesInput = withContext<HTMLInputElement, GPSCoordinatesInputProps>(LatLongInput, 'input');
